<template>
  <header :class="$style.root" class="pl-4 pr-3 py-3 d-flex align-items-center bg-gray-100">
    <div v-if="checkIfVLM()" :class="$style.logo" class="rounded-circle bg-vlm mr-3">
      <img src="../assets/amy-branco-icon.svg" class="w-70 h-auto ml-2 mt-6" alt="Assistente Virtual">
    </div>
    <div v-else :class="$style.logo" class="rounded-circle bg-primary mr-3">
      <img src="../assets/amy-branco-icon.svg" class="w-70 h-auto ml-2 mt-6" alt="Assistente Virtual">
    </div>
    <div :class="$style.text">
      <h1 v-if="checkIfVLM()" :class="$style.vlm">
        Assistente Virtual
      </h1>
      <h1 v-else class="text-primary m-0 mb-1">
        Assistente Virtual
      </h1>
      <span class="d-block lh-1"/>
    </div>
    <div class="ml-auto d-flex flex-wrap justify-content-end">
      <button v-if="checkDisableInput()" class="btn-reset p-2" @click="toggleAbout">
        <img v-if="checkIfVLM()" id="mk-open-help" src="../assets/shopping/vlm/question-icon.svg" alt="">
        <img v-else id="mk-open-help" src="../assets/question-icon.svg" alt="">
      </button>
      <button class="ml-2 btn-reset p-2" @click="close">
        <img v-if="checkIfVLM()" id="mk-chat-close" src="../assets/shopping/vlm/fechar-icon-verde.svg" alt="">
        <img v-else id="mk-chat-close" src="../assets/fechar-icon-verde.svg" alt="">
      </button>
    </div>
  </header>
</template>

<script>
  import { getQueryStringParams } from '../lib/utils';
  import {mapActions} from 'vuex';

  export default {
    name: 'Header',
    methods: {
      ...mapActions(['toggleAbout']),
      close() {
        window.parent && window.parent.postMessage('amy:close', '*');
      },
      checkDisableInput(){
          const params = getQueryStringParams(); 
          return params && params['disableInput'] !== 'true';
      },
      checkIfVLM(){
        const params = getQueryStringParams(); 
        return params && params['shoppingSlug'] === 'vlm';
      }
    }
  };
</script>

<style lang="scss" module>
  .root {
    z-index: 1000;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .logo {
    width: 60px;
    min-width: 45px;
    height: 60px;
    min-height: 45px;

    @media screen and (max-width: 350px) {
      width: 32px;
      min-width: 32px;
      height: 32px;
      min-height: 32px;
    }
  }

  .text {
    max-width: 160px;
  }

  .vlm {
    color: #c9b67f;
  }
</style>
